module.exports = __webpack_public_path__ + "static/media/left-hand-drawn-arrow.23759c09.svg";